import { useQuery, keepPreviousData } from '@tanstack/react-query'
import usePagination from 'hooks/usePagination'
import { getCustomTearsheetTemplateRequests } from 'services/tearsheets'

const useTemplateRequests = () => {
  const { pagination, handlePageChange, handleRowsChange, pageSizeOptions } = usePagination()

  const params = {
    pageOffset: pagination.pageOffset,
    pageSize: pagination.pageSize,
  }

  const {
    data: { data: requests, meta },
    isFetching,
  } = useQuery({
    queryKey: ['customTearsheetTemplateRequests', params],
    queryFn: () => getCustomTearsheetTemplateRequests(params),
    initialData: { data: [], meta: { itemCount: 0 } },
    refetchOnWindowFocus: false,
    throwOnError: true,
    placeholderData: keepPreviousData,
  })

  return {
    requests,
    itemCount: meta.itemCount,
    isFetching,
    page: pagination.page,
    pageSize: pagination.pageSize,
    pageSizeOptions,
    handlePageChange,
    handlePageSizeChange: handleRowsChange,
  }
}

export default useTemplateRequests
